/**
 * Fase 1F — Ruma Flow frontend multi-tenant flag helper.
 *
 * Regra estrita:
 *  - Somente o valor textual "true" (case-insensitive, sem espaços em torno)
 *    da variável ``REACT_APP_PLATFORM_AUTH_ENABLED`` ativa o modo global.
 *  - Ausente, vazio ou qualquer outro valor mantém o modo legado.
 *  - NENHUM fallback automático por erro de rede.
 *  - O helper é a única autoridade — evita re-interpretação em cada tela.
 */
export function isPlatformAuthEnabled() {
  const raw = process.env.REACT_APP_PLATFORM_AUTH_ENABLED;
  if (typeof raw !== "string") return false;
  return raw.trim().toLowerCase() === "true";
}
